module.exports = {"StatusCode":200,"Payload":[{"users":[{"_id":"us-west-2:10ac5a43-b958-4e9d-9105-6e777eb4f9cf","fullName":"Puddy","pic":"https://www.personality-database.com/profile_images/2223.png"},{"_id":"some-user-id1","fullName":"George Costanza","pic":"https://static.wikia.nocookie.net/seinfeld/images/7/76/George-costanza.jpg"},{"_id":"some-user-id2","fullName":"Newman","pic":"https://upload.wikimedia.org/wikipedia/en/8/8c/Newman_Seinfeld.jpg"}]}]}


//////////////////
// WEBPACK FOOTER
// ./src/payloads/aws/lambda/mocks/getTicketUsers.json
// module id = wk7D
// module chunks = 0